// メッセージ取得処理
export const GetMessage = (key1:string, key2:string, key3:string, key4:string) => {
    const messageDefinition = messages.find((v) => v.key1 === key1 && v.key2 === key2 && v.key3 === key3 && v.key4 === key4);
    var message = messageDefinition?.message;
    return message ? message : "メッセージ未定義です";
}
//----------------------------------------------------------------------
// 画面種別
//----------------------------------------------------------------------
// 広告主アカウント
export const UI_ACCOUNT_LIST = "acc01";
export const UI_ACCOUNT_MENU_LIST = "acc02";
export const UI_ACCOUNT_UNAPPROVED_LIST = "acc03";
export const UI_ACCOUNT_DETAIL = "acc11";
export const UI_ACCOUNT_EDIT = "acc21";

// アカウントグループ
export const UI_ACCOUNT_GROUP_LIST = "acg01";
export const UI_ACCOUNT_GROUP_DETAIL = "acg11";
export const UI_ACCOUNT_GROUP_EDIT = "acg21";
// ユーザー
export const UI_USER_LIST = "use01";
export const UI_USER_DETAIL = "use11";
export const UI_USER_EDIT = "use21";
export const UI_ROLE_EDIT = "rol21";
// マニュアルダウンロード
export const UI_MANUAL_DOWNLOAD = "man61";
// お知らせ&メール
export const UI_NOTIFY_LIST = "not01";
export const UI_NOTIFY_DETAIL = "not11";
export const UI_NOTIFY_EDIT = "not21";
export const UI_NOTIFY_CLIENT = "noc01";
// レポート
export const UI_REPORT_LIST = "rep01";
export const UI_REPORT_EDIT = "rep21";
export const UI_REPORT_DOWNLOAD = "rep61";
// マスタ(商品)
export const UI_MASTER_PRODUCT_LIST = "mpr01";
export const UI_MASTER_PRODUCT_EDIT = "mpr21";
// マスタ(業種)
export const UI_MASTER_INDUSTORY_LIST = "min01";
export const UI_MASTER_INDUSTORY_EDIT = "min21";
export const UI_MASTER_INDUSTORY_MODAL = "min71";
// マスタ(請求リソース)
export const UI_MASTER_BILLING_LIST = "mbi01";
export const UI_MASTER_BILLING_EDIT = "mbi21";
export const UI_MASTER_BILLING_MODAL = "mbi71";
// マスタ(業種カテゴリ)
export const UI_MASTER_CATEGORY_MODAL = "mca71";
// マニュアル管理
export const UI_MANUAL_LIST = "man01";
export const UI_MANUAL_UPLOAD = "man21";
// 確定請求金額
export const UI_INVOICE_LIST = "inv01";
export const UI_INVOICE_MENU_LIST = "inv02";
export const UI_INVOICE_DOWNLOAD = "inv61";
// 予算
export const UI_BUDGET_LIST = "bud01";
export const UI_BUDGET_DETAIL = "bud11";
export const UI_BUDGET_EDIT = "bud21";
// アカウントサマリ
export const UI_ACCOUNT_SUMMARY = "acs81";
// 個別サマリ
export const UI_INDIVIDUAL_SUMMARY = "ins81";
// 広告グループ
export const UI_ADGROUP_EDIT = "adg21";

//----------------------------------------------------------------------
// メッセージ定義
//----------------------------------------------------------------------
// メッセージ定義タイプ
type messageDefinition = {
    key1 : string,      // PF種別 ("0":Apollo, "1":Zeus, "2":MS)
    key2 : string,      // 画面種別
    key3 : string,      // メッセージレベル (S/E/W/V/I)
    key4 : string,      // メッセージ番号
    message : string,   // メッセージ
}
// メッセージ定義
const messages : messageDefinition[] = [
    //======================================================================
    // 広告主アカウント一覧、エラーメッセージ
    {key1: "0", key2: UI_ACCOUNT_LIST, key3: "E", key4: "0", message: "メニューの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_LIST, key3: "E", key4: "1", message: "アカウントの取得に失敗しました"},
    //----------------------------------------------------------------------
    // 広告主アカウントメニュー一覧、エラーメッセージ
    {key1: "0", key2: UI_ACCOUNT_MENU_LIST, key3: "E", key4: "0", message: "アカウントメニューの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_MENU_LIST, key3: "E", key4: "1", message: "アカウント情報の取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_MENU_LIST, key3: "E", key4: "2", message: "アカウント情報の更新に失敗しました"},
    // 広告主アカウントメニュー一覧、インフォメーションメッセージ
    {key1: "0", key2: UI_ACCOUNT_MENU_LIST, key3: "I", key4: "0", message: "更新に成功しました"},
    //----------------------------------------------------------------------
    // 広告主アカウント未承認一覧、エラーメッセージ
    {key1: "0", key2: UI_ACCOUNT_UNAPPROVED_LIST, key3: "E", key4: "0", message: "アカウントの更新に失敗しました"},
    // 広告主アカウント未承認一覧、インフォメーションメッセージ
    {key1: "0", key2: UI_ACCOUNT_UNAPPROVED_LIST, key3: "I", key4: "0", message: "更新に成功しました"},
    // 広告主アカウント未承認一覧、バリデーションメッセージ
    {key1: "0", key2: UI_ACCOUNT_UNAPPROVED_LIST, key3: "V", key4: "0", message: "広告主アカウントを選択してください"},
    //----------------------------------------------------------------------
    // 広告主アカウント詳細、エラーメッセージ
    {key1: "0", key2: UI_ACCOUNT_DETAIL, key3: "E", key4: "0", message: "アカウントの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_DETAIL, key3: "E", key4: "1", message: "アカウント情報が見つかりませんでした"},
    {key1: "0", key2: UI_ACCOUNT_DETAIL, key3: "E", key4: "2", message: "アカウントの削除に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_DETAIL, key3: "E", key4: "3", message: "アカウント承認状況の更新に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_DETAIL, key3: "E", key4: "4", message: "トラッカーIDの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_DETAIL, key3: "E", key4: "5", message: "トラッカーID移行元アカウント情報の取得に失敗しました"},
    // 広告主アカウント詳細、インフォメーションメッセージ
    {key1: "0", key2: UI_ACCOUNT_DETAIL, key3: "I", key4: "0", message: "削除に成功しました"},
    {key1: "0", key2: UI_ACCOUNT_DETAIL, key3: "I", key4: "1", message: "更新に成功しました"},
    {key1: "0", key2: UI_ACCOUNT_DETAIL, key3: "I", key4: "2", message: "トラッカーIDの取得に成功しました"},

    //----------------------------------------------------------------------
    // 広告主アカウント作成・編集、エラーメッセージ
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "E", key4: "0", message: "請求リソースの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "E", key4: "1", message: "メニューマスターの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "E", key4: "2", message: "アカウントの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "E", key4: "3", message: "アカウントの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "E", key4: "4", message: "アカウント情報が見つかりませんでした"},
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "E", key4: "5", message: "アカウントの作成に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "E", key4: "6", message: "アカウントの更新に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "E", key4: "7", message: "トラッカーID移行元アカウント情報の取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "E", key4: "8", message: "トラッカーID移行元アカウント一覧情報の取得に失敗しました"},

    // 広告主アカウント作成・編集、インフォメーションメッセージ
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "I", key4: "0", message: "作成に成功しました"},
    {key1: "0", key2: UI_ACCOUNT_EDIT, key3: "I", key4: "1", message: "更新に成功しました"},
    //======================================================================
    // アカウントグループ一覧、エラーメッセージ
    {key1: "0", key2: UI_ACCOUNT_GROUP_LIST, key3: "E", key4: "0", message: "アカウントグループの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_GROUP_LIST, key3: "E", key4: "1", message: "未承認アカウントの取得に失敗しました"},
    //----------------------------------------------------------------------
    // アカウントグループ詳細、エラーメッセージ
    {key1: "0", key2: UI_ACCOUNT_GROUP_DETAIL, key3: "E", key4: "0", message: "アカウントグループデータ取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_GROUP_DETAIL, key3: "E", key4: "1", message: "アカウントグループ情報が見つかりませんでした"},
    {key1: "0", key2: UI_ACCOUNT_GROUP_DETAIL, key3: "E", key4: "2", message: "アカウントグループの削除に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_GROUP_DETAIL, key3: "E", key4: "3", message: "トラッカーID移行アカウント情報の取得に失敗しました"},
    // アカウントグループ詳細、インフォメーションメッセージ
    {key1: "0", key2: UI_ACCOUNT_GROUP_DETAIL, key3: "I", key4: "0", message: "削除に成功しました"},
    //----------------------------------------------------------------------
    // アカウントグループ作成・編集、エラーメッセージ
    {key1: "0", key2: UI_ACCOUNT_GROUP_EDIT, key3: "E", key4: "0", message: "アカウントグループの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_GROUP_EDIT, key3: "E", key4: "1", message: "アカウントグループの作成に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_GROUP_EDIT, key3: "E", key4: "2", message: "アカウントグループの更新に失敗しました"},
    // アカウントグループ作成・編集、インフォメーションメッセージ
    {key1: "0", key2: UI_ACCOUNT_GROUP_EDIT, key3: "I", key4: "0", message: "作成に成功しました"},
    {key1: "0", key2: UI_ACCOUNT_GROUP_EDIT, key3: "I", key4: "1", message: "更新に成功しました"},
    // アカウントグループ作成・編集、バリデーションメッセージ
    {key1: "0", key2: UI_ACCOUNT_GROUP_EDIT, key3: "V", key4: "0", message: "必須入力項目です"},
    {key1: "0", key2: UI_ACCOUNT_GROUP_EDIT, key3: "V", key4: "1", message: "請求リソースを選択してください"},
    //======================================================================
    // ユーザー一覧、エラーメッセージ
    {key1: "0", key2: UI_USER_LIST, key3: "E", key4: "0", message: "ユーザー情報の取得に失敗しました"},
    {key1: "0", key2: UI_USER_LIST, key3: "E", key4: "1", message: "ロール情報の取得に失敗しました"},
    //----------------------------------------------------------------------
    // ユーザー詳細、エラーメッセージ
    {key1: "0", key2: UI_USER_DETAIL, key3: "E", key4: "0", message: "ロールとユーザーの紐付け解除に失敗しました"},
    {key1: "0", key2: UI_USER_DETAIL, key3: "E", key4: "1", message: "削除に失敗しました"},
    {key1: "0", key2: UI_USER_DETAIL, key3: "E", key4: "2", message: "ユーザー情報の取得に失敗しました"},
    // ユーザー詳細、インフォメーションメッセージ
    {key1: "0", key2: UI_USER_DETAIL, key3: "I", key4: "0", message: "自身のアカウントを削除した為、ログアウトしました"},
    // ユーザー詳細、バリデーションメッセージ
    {key1: "0", key2: UI_USER_DETAIL, key3: "V", key4: "0", message: "自身のアカウントを削除することはできません"},
    //----------------------------------------------------------------------
    // ユーザー作成・編集、エラーメッセージ
    {key1: "0", key2: UI_USER_EDIT, key3: "E", key4: "0", message: "ユーザー新規作成に失敗しました"},
    {key1: "0", key2: UI_USER_EDIT, key3: "E", key4: "1", message: "ユーザー更新に失敗しました"},
    {key1: "0", key2: UI_USER_EDIT, key3: "E", key4: "2", message: "ロールとユーザーの紐付けに失敗しました"},
    {key1: "0", key2: UI_USER_EDIT, key3: "E", key4: "3", message: "ロールとユーザーの紐付け解除に失敗しました"},
    {key1: "0", key2: UI_USER_EDIT, key3: "E", key4: "4", message: "アカウントグループ情報の取得に失敗しました"},
    {key1: "0", key2: UI_USER_EDIT, key3: "E", key4: "5", message: "ユーザー情報の取得に失敗しました"},
    {key1: "0", key2: UI_USER_EDIT, key3: "E", key4: "6", message: "サイドメニュー初期表示の更新に失敗しました"},
    // ユーザー作成・編集、インフォメーションメッセージ
    {key1: "0", key2: UI_USER_EDIT, key3: "I", key4: "0", message: "ユーザー・ロール新規登録に成功しました"},
    {key1: "0", key2: UI_USER_EDIT, key3: "I", key4: "1", message: "ユーザー・ロール更新に成功しました"},
    // ユーザー作成・編集、バリデーションメッセージ
    {key1: "0", key2: UI_USER_EDIT, key3: "V", key4: "0", message: "所有ロールは権限に関わらず1つ以上選択してください"},
    {key1: "0", key2: UI_USER_EDIT, key3: "V", key4: "1", message: "同じアカウントグループで複数のロールは付与できません"},
    {key1: "0", key2: UI_USER_EDIT, key3: "V", key4: "2", message: "メールアドレスが他のユーザーと重複しています"},
    {key1: "0", key2: UI_USER_EDIT, key3: "V", key4: "3", message: "ご自身のロール変更後は強制的にログアウトされますので、再度ログインしてください"},
    {key1: "0", key2: UI_USER_EDIT, key3: "V", key4: "4", message: "メールアドレスが他のユーザーと重複しています"},
    //----------------------------------------------------------------------
    // ロール作成・編集、エラーメッセージ
    {key1: "0", key2: UI_ROLE_EDIT, key3: "E", key4: "0", message: "ロール情報(アカウントグループ)の取得に失敗しました"},
    {key1: "0", key2: UI_ROLE_EDIT, key3: "E", key4: "1", message: "ロール情報の取得に失敗しました"},
    {key1: "0", key2: UI_ROLE_EDIT, key3: "E", key4: "2", message: "ロール情報の取得に失敗しました"},
    //======================================================================
    // マニュアルダウンロード、エラーメッセージ
    {key1: "0", key2: UI_MANUAL_DOWNLOAD, key3: "E", key4: "0", message: "ファイルのダウンロードに失敗しました"},
    {key1: "0", key2: UI_MANUAL_DOWNLOAD, key3: "E", key4: "1", message: "ダウンロードバケット名が未定義です"},
    {key1: "0", key2: UI_MANUAL_DOWNLOAD, key3: "E", key4: "2", message: "ダウンロードファイル名が未定義です"},
    //======================================================================
    // お知らせ一覧、エラーメッセージ
    {key1: "0", key2: UI_NOTIFY_LIST, key3: "E", key4: "0", message: "通知メッセージの取得に失敗しました"},
    //----------------------------------------------------------------------
    // お知らせ詳細、エラーメッセージ
    {key1: "0", key2: UI_NOTIFY_DETAIL, key3: "E", key4: "0", message: "データの取得に失敗しました"},
    {key1: "0", key2: UI_NOTIFY_DETAIL, key3: "E", key4: "1", message: "削除に失敗しました"},
    {key1: "0", key2: UI_NOTIFY_DETAIL, key3: "E", key4: "2", message: "メール送信に失敗しました"},
    {key1: "0", key2: UI_NOTIFY_DETAIL, key3: "E", key4: "3", message: "アカウント情報が見つかりませんでした"},
    // お知らせ詳細、インフォメーションメッセージ
    {key1: "0", key2: UI_NOTIFY_DETAIL, key3: "I", key4: "0", message: "削除に成功しました"},
    {key1: "0", key2: UI_NOTIFY_DETAIL, key3: "I", key4: "1", message: "メール送信に成功しました"},
    //----------------------------------------------------------------------
    // お知らせ作成・編集、エラーメッセージ
    {key1: "0", key2: UI_NOTIFY_EDIT, key3: "E", key4: "0", message: "データの取得に失敗しました"},
    {key1: "0", key2: UI_NOTIFY_EDIT, key3: "E", key4: "1", message: "ユーザー情報の取得に失敗しました"},
    {key1: "0", key2: UI_NOTIFY_EDIT, key3: "E", key4: "2", message: "に失敗しました"},
    {key1: "0", key2: UI_NOTIFY_EDIT, key3: "E", key4: "3", message: "に失敗しました"},
    {key1: "0", key2: UI_NOTIFY_EDIT, key3: "E", key4: "4", message: "配信ユーザーが未選択の場合は、メールは送信できません"},
    // お知らせ作成・編集、インフォメーションメッセージ
    {key1: "0", key2: UI_NOTIFY_EDIT, key3: "I", key4: "0", message: "に成功しました"},
    {key1: "0", key2: UI_NOTIFY_EDIT, key3: "I", key4: "1", message: "に成功しました"},
    //----------------------------------------------------------------------
    // お知らせクライアント、エラーメッセージ
    {key1: "0", key2: UI_NOTIFY_CLIENT, key3: "E", key4: "0", message: "メッセージ削除に失敗しました"},
    {key1: "0", key2: UI_NOTIFY_CLIENT, key3: "E", key4: "1", message: "メッセージ一覧取得に失敗しました"},
    {key1: "0", key2: UI_NOTIFY_CLIENT, key3: "E", key4: "2", message: "メッセージ取得に失敗しました"},
    {key1: "0", key2: UI_NOTIFY_CLIENT, key3: "E", key4: "3", message: "通知メッセージの取得に失敗しました"},
    //======================================================================
    // レポート一覧、エラーメッセージ
    {key1: "0", key2: UI_REPORT_LIST, key3: "E", key4: "0", message: "レポートの取得に失敗しました"},
    //----------------------------------------------------------------------
    // レポート作成・編集、エラーメッセージ
    {key1: "0", key2: UI_REPORT_EDIT, key3: "E", key4: "0", message: "レポートの取得に失敗しました"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "E", key4: "1", message: "広告主アカウントキャンペーンの取得に失敗しました"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "E", key4: "2", message: "レポートの設定に失敗しました"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "E", key4: "3", message: "レポート作成処理の起動に失敗しました"},
    // レポート作成・編集、インフォメーションメッセージ
    {key1: "0", key2: UI_REPORT_EDIT, key3: "I", key4: "0", message: "レポートの設定に成功しました"},
    // レポート作成・編集、バリデーションメッセージ
    {key1: "0", key2: UI_REPORT_EDIT, key3: "V", key4: "0", message: "必須入力項目です"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "V", key4: "1", message: "キャンペーン・広告は選択できません"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "V", key4: "2", message: "時間は選択できません"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "V", key4: "3", message: "開始日時を入力して下さい"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "V", key4: "4", message: "終了日時を入力して下さい"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "V", key4: "5", message: "終了日時以前の日時を開始日時に入力して下さい"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "V", key4: "6", message: "開始日時以降の日時を終了日時に入力して下さい"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "V", key4: "7", message: "期間は13ヶ月以内で入力して下さい"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "V", key4: "8", message: "曜日を入力して下さい"},
    {key1: "0", key2: UI_REPORT_EDIT, key3: "V", key4: "9", message: "スケジュール日時を入力して下さい"},
    //----------------------------------------------------------------------
    // レポートダウンロード、エラーメッセージ
    {key1: "0", key2: UI_REPORT_DOWNLOAD, key3: "E", key4: "0", message: "レポートCSVダウンロードに失敗しました"},
    //======================================================================
    // 商品マスタ一覧、エラーメッセージ
    {key1: "0", key2: UI_MASTER_PRODUCT_LIST, key3: "E", key4: "0", message: "商品マスタの取得に失敗しました"},
    {key1: "0", key2: UI_MASTER_PRODUCT_LIST, key3: "E", key4: "1", message: "商品マスタの削除に失敗しました"},
    // 商品マスタ一覧、インフォメーションメッセージ
    {key1: "0", key2: UI_MASTER_PRODUCT_LIST, key3: "I", key4: "0", message: "削除に成功しました"},
    //----------------------------------------------------------------------
    // 商品マスタ作成・編集、エラーメッセージ
    {key1: "0", key2: UI_MASTER_PRODUCT_EDIT, key3: "E", key4: "0", message: "商品マスタの取得に失敗しました"},
    {key1: "0", key2: UI_MASTER_PRODUCT_EDIT, key3: "E", key4: "1", message: "商品マスタの登録に失敗しました"},
    {key1: "0", key2: UI_MASTER_PRODUCT_EDIT, key3: "E", key4: "2", message: "商品マスタの更新に失敗しました"},
    // 商品マスタ作成・編集、インフォメーションメッセージ
    {key1: "0", key2: UI_MASTER_PRODUCT_EDIT, key3: "I", key4: "0", message: "登録に成功しました"},
    {key1: "0", key2: UI_MASTER_PRODUCT_EDIT, key3: "I", key4: "1", message: "更新に成功しました"},
    // 商品マスタ作成・編集、バリデーションメッセージ
    {key1: "0", key2: UI_MASTER_PRODUCT_EDIT, key3: "V", key4: "0", message: "業種は必須項目です"},
    //======================================================================
    // 業種マスタ一覧、エラーメッセージ
    {key1: "0", key2: UI_MASTER_INDUSTORY_LIST, key3: "E", key4: "0", message: "業種マスタの取得に失敗しました"},
    {key1: "0", key2: UI_MASTER_INDUSTORY_LIST, key3: "E", key4: "1", message: "業種マスタの削除に失敗しました"},
    // 業種マスタ一覧、インフォメーションメッセージ
    {key1: "0", key2: UI_MASTER_INDUSTORY_LIST, key3: "I", key4: "0", message: "削除に成功しました"},
    //----------------------------------------------------------------------
    // 業種マスタ作成・編集、エラーメッセージ
    {key1: "0", key2: UI_MASTER_INDUSTORY_EDIT, key3: "E", key4: "0", message: "業種マスタの取得に失敗しました"},
    {key1: "0", key2: UI_MASTER_INDUSTORY_EDIT, key3: "E", key4: "1", message: "業種マスタの登録に失敗しました"},
    {key1: "0", key2: UI_MASTER_INDUSTORY_EDIT, key3: "E", key4: "2", message: "業種マスタの更新に失敗しました"},
    {key1: "0", key2: UI_MASTER_INDUSTORY_EDIT, key3: "E", key4: "3", message: "業種カテゴリマスタの取得に失敗しました"},
    // 業種マスタ作成・編集、インフォメーションメッセージ
    {key1: "0", key2: UI_MASTER_INDUSTORY_EDIT, key3: "I", key4: "0", message: "登録に成功しました"},
    {key1: "0", key2: UI_MASTER_INDUSTORY_EDIT, key3: "I", key4: "1", message: "更新に成功しました"},
    // 業種マスタ作成・編集、バリデーションメッセージ
    {key1: "0", key2: UI_MASTER_INDUSTORY_EDIT, key3: "V", key4: "0", message: "業種は必須項目です"},
    // 業種マスタモーダル、エラーメッセージ
    {key1: "0", key2: UI_MASTER_INDUSTORY_MODAL, key3: "E", key4: "0", message: "業種カテゴリの取得に失敗しました"},
    {key1: "0", key2: UI_MASTER_INDUSTORY_MODAL, key3: "E", key4: "1", message: "業種の取得に失敗しました"},
    {key1: "0", key2: UI_MASTER_INDUSTORY_MODAL, key3: "E", key4: "2", message: "商品の取得に失敗しました"},
    //======================================================================
    // 請求リソースマスタ一覧、エラーメッセージ
    {key1: "0", key2: UI_MASTER_BILLING_LIST, key3: "E", key4: "0", message: "請求リソースマスタの取得に失敗しました"},
    {key1: "0", key2: UI_MASTER_BILLING_LIST, key3: "E", key4: "1", message: "請求リソースマスタの削除に失敗しました"},
    // 請求リソースマスタ一覧、インフォメーションメッセージ
    {key1: "0", key2: UI_MASTER_BILLING_LIST, key3: "I", key4: "0", message: "削除に成功しました"},
    //----------------------------------------------------------------------
    // 請求リソースマスタ作成・編集、エラーメッセージ
    {key1: "0", key2: UI_MASTER_BILLING_EDIT, key3: "E", key4: "0", message: "請求リソースマスタの取得に失敗しました"},
    {key1: "0", key2: UI_MASTER_BILLING_EDIT, key3: "E", key4: "1", message: "請求リソースマスタの登録に失敗しました"},
    {key1: "0", key2: UI_MASTER_BILLING_EDIT, key3: "E", key4: "2", message: "請求リソースマスタの更新に失敗しました"},
    {key1: "0", key2: UI_MASTER_BILLING_EDIT, key3: "E", key4: "3", message: "請求リソースカテゴリマスタの取得に失敗しました"},
    // 請求リソースマスタ作成・編集、インフォメーションメッセージ
    {key1: "0", key2: UI_MASTER_BILLING_EDIT, key3: "I", key4: "0", message: "登録に成功しました"},
    {key1: "0", key2: UI_MASTER_BILLING_EDIT, key3: "I", key4: "1", message: "更新に成功しました"},
    // 請求リソースマスタモーダル、エラーメッセージ
    {key1: "0", key2: UI_MASTER_BILLING_MODAL, key3: "E", key4: "0", message: "請求リソースの取得に失敗しました"},
    {key1: "0", key2: UI_MASTER_BILLING_MODAL, key3: "E", key4: "1", message: "請求リソースの作成に失敗しました"},
    {key1: "0", key2: UI_MASTER_BILLING_MODAL, key3: "E", key4: "2", message: "請求リソースの更新に失敗しました"},
    // 請求リソースマスタモーダル、インフォメーションメッセージ
    {key1: "0", key2: UI_MASTER_BILLING_MODAL, key3: "I", key4: "0", message: "作成に成功しました"},
    {key1: "0", key2: UI_MASTER_BILLING_MODAL, key3: "I", key4: "1", message: "更新に成功しました"},
    //======================================================================
    // 業種カテゴリマスタモーダル、エラーメッセージ
    {key1: "0", key2: UI_MASTER_CATEGORY_MODAL, key3: "E", key4: "0", message: "業種カテゴリの取得に失敗しました"},
    {key1: "0", key2: UI_MASTER_CATEGORY_MODAL, key3: "E", key4: "1", message: "業種の取得に失敗しました"},
    //======================================================================
    // マニュアル管理、エラーメッセージ
    {key1: "0", key2: UI_MANUAL_LIST, key3: "E", key4: "0", message: "マニュアル情報の取得に失敗しました"},
    // マニュアルアップロード、エラーメッセージ
    {key1: "0", key2: UI_MANUAL_UPLOAD, key3: "E", key4: "0", message: "マニュアルのアップロードに失敗しました"},
    {key1: "0", key2: UI_MANUAL_UPLOAD, key3: "E", key4: "1", message: "ファイルの拡張子指定に誤りがあります"},
    // マニュアルアップロード、インフォメーションメッセージ
    {key1: "0", key2: UI_MANUAL_UPLOAD, key3: "I", key4: "0", message: "マニュアルを更新しました"},
    //======================================================================
    // 確定請求金額一覧、エラーメッセージ
    {key1: "0", key2: UI_INVOICE_LIST, key3: "E", key4: "0", message: "確定請求金額の取得に失敗しました"},
    // 確定請求金額メニュー一覧、エラーメッセージ
    {key1: "0", key2: UI_INVOICE_MENU_LIST, key3: "E", key4: "0", message: "確定請求金額(メニュー)の取得に失敗しました"},
    // 確定請求金額ダウンロード、エラーメッセージ
    {key1: "0", key2: UI_INVOICE_DOWNLOAD, key3: "E", key4: "0", message: "請求CSVダウンロードに失敗しました"},
    //======================================================================
    // 予算一覧、エラーメッセージ
    {key1: "0", key2: UI_BUDGET_LIST, key3: "E", key4: "0", message: "広告主アカウント月額予算の取得に失敗しました"},
    {key1: "0", key2: UI_BUDGET_LIST, key3: "E", key4: "1", message: "キャンペーン種別の取得に失敗しました"},
    //----------------------------------------------------------------------
    // 予算詳細、エラーメッセージ
    {key1: "0", key2: UI_BUDGET_DETAIL, key3: "E", key4: "0", message: "予算枠番号マスターの取得に失敗しました"},
    {key1: "0", key2: UI_BUDGET_DETAIL, key3: "E", key4: "1", message: "広告主アカウント月額予算の取得に失敗しました"},
    {key1: "0", key2: UI_BUDGET_DETAIL, key3: "E", key4: "2", message: "広告主アカウント月額実績の取得に失敗しました"},
    //----------------------------------------------------------------------
    // 予算作成・編集、エラーメッセージ
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "0", message: "予算枠番号マスターの取得に失敗しました"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "1", message: "広告主アカウント予算の取得に失敗しました"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "2", message: "広告主アカウント月額実績の取得に失敗しました"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "3", message: "広告主アカウントメニューの取得に失敗しました"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "4", message: "広告主アカウントメニュー情報が見つかりませんでした"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "5", message: "広告主アカウント予算の更新に失敗しました"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "6", message: "広告主アカウントメニュー予算の更新に失敗しました"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "7", message: "広告主アカウント予算チェックに失敗しました"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "8", message: "メール広告の予算を確認してください"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "9", message: "予算変更時に以下のエラーが発生しています。メニュー変更ボタンを押下してください。\r\n"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "10", message: "Zuesアカウント予算情報取得に失敗しました"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "12", message: "パフォーマンス広告配信種別毎予算の取得に失敗しました"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "13", message: "パフォーマンス広告配信種別毎予算の更新に失敗しました"},
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "E", key4: "14", message: "パフォーマンス広告配信種別毎予算下限値の取得に失敗しました"},
    // 予算作成・編集、インフォメーションメッセージ
    {key1: "0", key2: UI_BUDGET_EDIT, key3: "I", key4: "0", message: "更新に成功しました"},
    //======================================================================
    // アカウントサマリ、エラーメッセージ
    {key1: "0", key2: UI_ACCOUNT_SUMMARY, key3: "E", key4: "0", message: "一覧データの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_SUMMARY, key3: "E", key4: "1", message: "グラフデータの取得に失敗しました"},
    {key1: "0", key2: UI_ACCOUNT_SUMMARY, key3: "E", key4: "2", message: "データの取得に失敗しました"},
    //======================================================================
    // 個別サマリ、エラーメッセージ
    {key1: "0", key2: UI_INDIVIDUAL_SUMMARY, key3: "E", key4: "0", message: "データの取得に失敗しました"},
    //======================================================================
]
